// import { Tooltip } from 'bootstrap';

(function ($) {
    /* Custom JS */
    // let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    // let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //     return new Tooltip(tooltipTriggerEl);
    // });

    //Adds class to link identifying local or external
    // Array.from(document.querySelectorAll('a')).forEach(a => {
    //     a.classList.add(location.hostname === a.hostname || !a.hostname.length ? 'local' : 'external');
    // });

    $(window).on('load', function () {

        //Add class to remove spaces from Bal Harbour in Paragraphs
        
        // $('p, h1, h2, h3, h4, h5, a:not([title])').html(function(){
        //     return $(this).html().replace(/Bal Harbour/g, '<span class="no-break">Bal Harbour</span>');
        // }); 

       var term = "Bal Harbour";

        $('body *:contains("' + term + '")')
        .not(':has(:contains("' + term + '"))')
        .contents().each(function() {
            // nodeType for text nodes is 3
            if (this.nodeType === 3 && this.textContent.includes(term)) {
            var html = this.textContent.replace(term, 'Bal&nbsp;Harbour')
            // replace text node with html
            $(this).replaceWith(html)
            }

        })



  

        //try to fix accessbility issue on event calendar

        $(".tribe-filter-bar-c-filter__container[aria-hidden='true']").find(".tribe-filter-bar-c-filter__filters-fieldset button").attr('tabindex', -1);

        //apply alt tag to all images with missing alt tags

        $('img:not([alt])').attr('alt', 'Bal Harbour Miami');
        $('img[alt=""]').prop('alt', 'Bal Harbour Miami');


        $.expr[':'].external = function (a) {
            return (
                !a.href.match(/^mailto\:/) &&
                !a.href.match(/^https:\/\/(www\.)?balharbourfl\./) &&
                !a.href.match(/^https:\/\/(www\.)?balharbourflorida\./) &&
                // !a.href.match(/^https:\/\/(www\.)?balharbourvisitor\.fuseideas\./) &&
                // !a.href.match(/^https:\/\/(www\.)?balharbour\.fuseideas\./) &&
                !a.href.match(/^tel\:/) &&
                a.hostname != location.hostname &&
                !a.href.match(/^#/)
            );
        };
        
        
        // add tel class to all phone numbers
        $('a[href^="tel:"]').each(function () {
            $(this).addClass('telephone');
        });

        // OPEN 3RD PARTY SITE IN NEW TAB/WINDOW
        // $('#url_link').on('click', function () {
        //     window.open(this.href);
        //     return false;
        // }); testing

        // ADD BOOTSTRAP DATA-TOGGLE ATTRIBUTE TO THE LINKS
        // $('a:external').attr('data-bs-toggle', 'modal');
        // $('a:external').attr('data-bs-target', '#speedbump');
        
        // $('a:external').not('.stretched-link').addClass('external');
        $('a:external').not('.stretched-link').not('.lf-gate').not('.lf-link-gate').addClass('external');

        // $(function () {
        //     $('a.external').on('click', function () {
        //         var url = $(this).attr('href');
        //         var title = $(this).attr('title');
        //         console.log(url);
        //         $('#url_link').attr('href', url);
        //         $('h3#speedbump-title').replaceWith('<h3 id="speedbump-title">' + title + '</h3>');
        //         $('#url_link').on('click', function () {
        //             $('#speedbump').modal('hide');
        //         }); 
        //     });
        // });


    });

    setTimeout(function () {
        let searchTerm = $('.ss360-custom-search__searchbox').val();
        $('.page-title .search-term').text(searchTerm);
        // $('#google_language_translator select option:first-child()').text('English');
    }, 500);

    // Back to top button
    let backToTopBtn = document.getElementById('back-to-top');
    let rootElement = document.documentElement;

    if (backToTopBtn) {
        // When the user scrolls down 100px from the top of the document, show the button
        window.onscroll = function () {
            scrollFunction();
        };

        backToTopBtn.addEventListener('click', scrollToTop);

        function scrollFunction() {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                backToTopBtn.style.display = 'block';
            } else {
                backToTopBtn.style.display = 'none';
            }
        }

        // When the user clicks on the button, scroll to the top of the document
        function scrollToTop() {
            // Scroll to top logic
            rootElement.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }

})(jQuery);